export default "__VITE_ASSET__7f69d08b__"